import React from 'react';
import { createNativeStackNavigator } from '@react-navigation/native-stack';
import { AppRoutes } from "navigations/app-routes";
import _ from "lodash";
import { stackProps } from "utils/helper-navigation";
import HelperString from "utils/helper-string";
import { createPageTitle } from 'utils/helper-page-title'
import ManagementEmployeesTeamsScene from 'scenes/management/employees/teams'
import ManagementEmployeesTeamSceneComponent from 'scenes/management/employees/team'
import ManagementEmployeesEmployeeScene from 'scenes/management/employees/employee'

const Stack = createNativeStackNavigator();

const screens = {
	[AppRoutes.MANAGEMENT_EMPLOYEES_TEAMS_INDEX]: {
		component: ManagementEmployeesTeamsScene,
	},
	[AppRoutes.MANAGEMENT_EMPLOYEES_TEAMS_VIEW]: {
		component: ManagementEmployeesTeamSceneComponent,
	},
	[ AppRoutes.MANAGEMENT_EMPLOYEES_EMPLOYEE_VIEW ]: {
		component: ManagementEmployeesEmployeeScene,
	}
}

const ManagementEmployeesNavigator = ( props ) => {
	return (
		<Stack.Navigator
			{ ...stackProps }>

			{ _.map( screens, ( screen, name ) => {
				return (
					<Stack.Screen
						key={ HelperString.hash( `ManagementEmployeesNavigator`, name ) }
						name={ name }
						options={{
							title: createPageTitle( _.get( screen, 'title', null ) )
						}}
						component={ screen.component }
					/>
				);
			})}
		</Stack.Navigator>
	);
};

export default ManagementEmployeesNavigator
